import ImageIcon from '@mui/icons-material/Image';
import { Grid } from '@mui/material';
import { useState } from 'react';

import { ColorTypeButton } from '@/shared/constants';
import SingleIconButton from '../SingleIconButton';
import { ScrollableDialogProps } from './ScrollableDialogProps';

export type SingleImageAndBtnCellProps = {
  url: string;
  title: string;

  btnLabel?: string;
  btnColor?: ColorTypeButton;
  cancelTextBtn?: string;
};

const SingleImageAndBtnCellModal: React.FC<SingleImageAndBtnCellProps> = ({
  url,
  title,

  cancelTextBtn = 'Cerrar',
  btnLabel = 'Ver imagen',
  btnColor = 'default',
}) => {
  const [openPhotoModal, setOpenPhotoModal] = useState(false);

  const onClose = () => {
    setOpenPhotoModal(false);
  };

  if (!url) return 'N/A';

  return (
    <>
      <SingleIconButton
        startIcon={<ImageIcon />}
        color={btnColor as any}
        label={btnLabel}
        onClick={() => {
          setOpenPhotoModal(true);
        }}
      />

      <ScrollableDialogProps
        title={title}
        open={openPhotoModal}
        onClose={onClose}
        cancelTextBtn={cancelTextBtn}
        contentNode={
          <Grid container justifyContent="center">
            <img
              src={
                url ||
                'https://www.thermaxglobal.com/wp-content/uploads/2020/05/image-not-found.jpg'
              }
              alt={title}
              style={{ width: '100%' }}
            />
          </Grid>
        }
      />
    </>
  );
};

export default SingleImageAndBtnCellModal;
